<template>
    <div class="scroll-button" :class="{ 'visible': isVisible, 'hidden': !isVisible }">
        <button 
            @click="scrollDown" 
            class="scroll-btn" 
            aria-label="Scroll down"
        >
            <i class="chevron-down"></i>Scroll
        </button>
    </div>
</template>

<script>
export default {
    name: 'ScrollButton',
    data() {
        return {
            isVisible: false,
            activeTabContent: null
        }
    },
    mounted() {
        console.log('ScrollButton mounted');
        // Initial setup with a slight delay to ensure DOM is ready
        setTimeout(() => {
            this.setupScrollListener();
        }, 100);

        // Listen for tab changes
        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('nav-link')) {
                setTimeout(() => {
                    this.handleTabChange();
                }, 100);
            }
        });

        // Add scroll event listener to tab-content
        const tabContent = document.querySelector('.tab-content');
        if (tabContent) {
            tabContent.addEventListener('scroll', this.checkScroll);
        }
    },
    beforeDestroy() {
        const tabContent = document.querySelector('.tab-content');
        if (tabContent) {
            tabContent.removeEventListener('scroll', this.checkScroll);
        }
    },
    methods: {
        setupScrollListener() {
            // Get the tab content container
            const tabContent = document.querySelector('.tab-content');
            if (tabContent) {
                this.activeTabContent = tabContent;
                this.checkScrollability();
                console.log('Scroll listener setup complete');
            } else {
                console.log('Tab content not found');
            }
        },
        handleTabChange() {
            console.log('Tab change detected');
            setTimeout(() => {
                this.checkScrollability();
            }, 100);
        },
        checkScrollability() {
            const tabContent = document.querySelector('.tab-content');
            if (tabContent) {
                const contentHeight = tabContent.scrollHeight;
                const visibleHeight = tabContent.clientHeight;
                const shouldBeVisible = contentHeight > visibleHeight;
                
                console.log('Content height:', contentHeight);
                console.log('Visible height:', visibleHeight);
                console.log('Should be visible:', shouldBeVisible);
                
                this.isVisible = shouldBeVisible;
            }
        },
        checkScroll() {
            const tabContent = document.querySelector('.tab-content');
            if (tabContent) {
                const scrollPosition = tabContent.scrollTop + tabContent.clientHeight;
                const isAtBottom = scrollPosition >= tabContent.scrollHeight - 20;
                const shouldBeVisible = !isAtBottom && tabContent.scrollHeight > tabContent.clientHeight;
                
                this.isVisible = shouldBeVisible;
            }
        },
        scrollDown() {
            const tabContent = document.querySelector('.tab-content');
            if (tabContent) {
                const currentScroll = tabContent.scrollTop;
                tabContent.scrollTo({
                    top: currentScroll + 300,
                    behavior: 'smooth'
                });
            }
        }
    }
}
</script>

<style scoped>
.scroll-button {
    position: fixed;
    bottom: 6rem;
    left: 62%;
    transform: translateX(-50%);
    z-index: 999;
    transition: opacity 0.3s;
    width: 200px;
    text-align: center;
    margin: auto;
    opacity: 0;
    pointer-events: none;
}

.scroll-button.visible {
    opacity: 1;
    pointer-events: auto;
}

.scroll-button.hidden {
    opacity: 0;
    pointer-events: none;
}

.scroll-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
    color: white;
    background-color: rgb(0 59 51);
    border-radius: 9999px;
    transition: all 0.3s;
    margin: auto;
    width: 100%;
    font-size: 17px;
    font-weight: bold;
}

.scroll-btn:hover {
    background-color: rgba(0, 0, 0, 0.7);
}

.chevron-down {
    width: 1rem;
    height: 1rem;
    border: solid white;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    animation: bounce 1s infinite;
}

@keyframes bounce {
    0%, 100% {
        transform: rotate(45deg) translate(-25%, -25%);
    }
    50% {
        transform: rotate(45deg) translate(0, 0);
    }
}
</style>